var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"view-container"},[_c('transition',{attrs:{"name":"el-fade-in","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.caches}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }